import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MinimizeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MinimizeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_46_2766)">
        <path
          d="M11.4705 17.296C11.3349 17.1603 11.251 16.9729 11.251 16.7657L11.2506 7.23528C11.2506 6.82096 11.5862 6.48536 12.0005 6.48536C12.4149 6.48536 12.7505 6.82096 12.7505 7.23528L12.7508 16.7657C12.7508 17.18 12.4152 17.5156 12.0009 17.5156C11.7937 17.5156 11.6062 17.4317 11.4705 17.296Z"
          fill={isGradient ? `url(#${gradientId})` : fill}
        />
        <path
          d="M6.70517 12.5306C6.56948 12.395 6.48558 12.2075 6.48558 12.0003C6.48558 11.586 6.82118 11.2504 7.23551 11.2504L16.7659 11.2507C17.1802 11.2507 17.5158 11.5863 17.5158 12.0007C17.5158 12.415 17.1802 12.7506 16.7659 12.7506L7.2355 12.7502C7.02834 12.7502 6.84086 12.6663 6.70517 12.5306Z"
          fill={isGradient ? `url(#${gradientId})` : fill}
        />
        <path
          d="M4.92894 19.0721C1.03008 15.1732 1.03009 8.8288 4.92894 4.92995C8.82779 1.03109 15.1722 1.0311 19.0711 4.92995C22.9699 8.82881 22.9699 15.1732 19.0711 19.0721C15.1722 22.9709 8.82779 22.9709 4.92894 19.0721ZM17.9859 6.01515C14.6851 2.71435 9.31493 2.71436 6.01413 6.01515C2.71334 9.31595 2.71334 14.6861 6.01413 17.9869C9.31493 21.2877 14.6851 21.2877 17.9859 17.9869C21.2867 14.6861 21.2867 9.31594 17.9859 6.01515Z"
          fill={isGradient ? `url(#${gradientId})` : fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_46_2766">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MinimizeIcon;
